import React, { useContext, useState } from 'react';
import { Button, ButtonProps } from '@kizi/core-components';
import {
  useWizardService,
  useField,
  ComparatorContext,
} from '@kizi/comparator-core';
import { InnerModalComponentProps } from '../ProductNew';
import {
  AffiliateDataProvider,
  InnerModalForAffiliates,
} from '../modals/InnerModalForAffiliates';
import { Window } from '../Window';

export interface ComparisonSubmitButtonProps extends ButtonProps {
  data;
  fieldName: string;
  nextIndex: number;
  onSubmitFn?: (service, data) => void;
  isProductEnabled: boolean;
}

const InnerModalComponent: React.FC<InnerModalComponentProps> = ({
  shouldOpenNewTab,
  data,
  nextIndex,
  registerAnalyticsAddToCartEvent,
  providerName,
  onClose,
  onSubmitFn,
}) => (
  <AffiliateDataProvider>
    <InnerModalForAffiliates
      supplierName={providerName}
      onClose={onClose}
      handleSubmitAttributes={{
        shouldOpenNewTab,
        data,
        nextIndex,
        registerAnalyticsAddToCartEvent,
      }}
      onSubmitFn={onSubmitFn}
    />
  </AffiliateDataProvider>
);

export const ComparisonSubmitButton: React.FC<ComparisonSubmitButtonProps> = ({
  data,
  fieldName,
  nextIndex,
  onSubmitFn,
  isProductEnabled,
  ...buttonProps
}) => {
  const { orderType, incentive, provider } = data;
  const { name } = useContext(ComparatorContext);
  const field = useField(fieldName);
  const service = useWizardService();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const hideModal = () => setShowConfirmationModal(false);
  const isOverstappen = name.includes('os-');
  const shouldOpenApplyModal =
    name === 'os-health' && orderType === 'AFFILIATE' && incentive !== null;
  const { name: providerName } = provider;

  if (!service) return null;

  let onSubmitClick = () => {
    field?.set({
      value: JSON.stringify(data),
    });
    service?.send({ type: 'GOTO', index: nextIndex });
  };

  if (onSubmitFn) {
    onSubmitClick = () => {
      field?.set({
        value: JSON.stringify(data),
      });
      onSubmitFn(service, data);
    };
  }
  const test = () => console.log('test');
  return (
    <>
      <Button
        variant="primary"
        disabled={!isProductEnabled}
        onClick={
          shouldOpenApplyModal
            ? () => setShowConfirmationModal(!showConfirmationModal)
            : onSubmitClick
        }
        {...buttonProps}
      >
        {name === 'os-triple-play'
          ? 'Bekijk'
          : isOverstappen
            ? 'Aanvragen'
            : 'Ga verder'}
      </Button>
      {name === 'os-health' && (
        <Window
          type="modal"
          show={showConfirmationModal}
          title="Bol cadeaukaart"
          onClose={hideModal}
          showIcon
          modalProps={{
            show: showConfirmationModal,
            modalContainerDivProps: { width: '400px !important' },
            children: (
              <InnerModalComponent
                shouldOpenNewTab={shouldOpenApplyModal}
                data={data}
                nextIndex={nextIndex}
                registerAnalyticsAddToCartEvent={() => test()}
                onClose={hideModal}
                providerName={providerName}
                onSubmitFn={onSubmitFn}
              />
            ),
          }}
        >
          <InnerModalComponent
            shouldOpenNewTab={shouldOpenApplyModal}
            data={data}
            nextIndex={nextIndex}
            registerAnalyticsAddToCartEvent={() => test()}
            onClose={hideModal}
            providerName={providerName}
            onSubmitFn={onSubmitFn}
          />
        </Window>
      )}
    </>
  );
};
